module.exports = __webpack_public_path__ + "img/03.f1b54bcc.svg";